module.exports = __webpack_public_path__ + "static/img/mainbusiness03.db3a5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/mainbusiness03.png
// module id = 26oG
// module chunks = 1